import { EditIcon } from "@/assets/icons/admin";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
  getKeyValue,
} from "@nextui-org/react";
import { useEffect, useState } from "react";
import EditProviderRate from "./edit";
import { toast } from "react-toastify";

export interface ProviderShareData {
  id: number;
  provider: string;
  category: string;
  rates: number[];
}

const ProviderRateConfig = () => {
  const [data, setData] = useState<ProviderShareData[] | undefined>(undefined);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState<
    ProviderShareData | undefined
  >(undefined);

  useEffect(() => {
    fetchProviderRate();
  }, []);

  const fetchProviderRate = () => {
    fetch(`${import.meta.env.VITE_GGR_API_URI}/config/rates`)
      .then((res) => res.json())
      .then((data) => {
        setData(data.data);
      });
  };

  const columns = [
    {
      key: "provider",
      label: "provider",
    },
    {
      key: "category",
      label: "category",
    },
    {
      key: "rates[0]",
      label: "0-100,000",
    },
    {
      key: "rates[1]",
      label: "100,001-200,000",
    },
    {
      key: "rates[2]",
      label: "200,001-300,000",
    },
    {
      key: "rates[3]",
      label: "300,001-400,000",
    },
    {
      key: "rates[4]",
      label: "400,001-500,000",
    },
    {
      key: "rates[5]",
      label: "500,001-600,000",
    },
    {
      key: "rates[6]",
      label: "600,001-700,000",
    },
    {
      key: "rates[7]",
      label: "700,001-800,000",
    },
    {
      key: "rates[8]",
      label: "800,001-900,000",
    },
    {
      key: "rates[9]",
      label: "900,001-1,000,000",
    },
    {
      key: "action",
      label: "Action",
    },
  ];

  return (
    <div>
      {isEditing ? (
        <EditProviderRate
          data={selectedProvider}
          onClose={() => {
            setIsEditing(false);
            fetchProviderRate();
          }}
        />
      ) : (
        <div>
          <div className="font-ubuntu float-left text-center text-2xl  text-sm font-semibold text-white sm:text-lg">
            <p className="hidden sm:block">Provider Rate</p>
          </div>
          <div className="flex w-full flex-col gap-4"></div>
          {data !== undefined && (
            <div className="w-full sm:mt-5">
              <div className="w-full overflow-x-auto">
                <Table
                  removeWrapper
                  className="table-striped table-striped-even table"
                >
                  <TableHeader className="rounded-none" columns={columns}>
                    {(column) => (
                      <TableColumn key={column.key}>
                        <div className="white-op flex">{column.label}</div>
                      </TableColumn>
                    )}
                  </TableHeader>
                  <TableBody items={data}>
                    {(item) => (
                      <TableRow key={item.provider}>
                        {(columnKey) => (
                          <TableCell>
                            {columnKey === "no" ? (
                              getKeyValue(item, columnKey) + "."
                            ) : columnKey === "provider" ? (
                              <div>{getKeyValue(item, columnKey)}</div>
                            ) : columnKey === "category" ? (
                              <div>{getKeyValue(item, columnKey)}</div>
                            ) : columnKey === "action" ? (
                              <div className="flex items-center">
                                <Button
                                  isIconOnly
                                  className="transparent-bg h-auto w-auto"
                                  onClick={() => {
                                    setSelectedProvider(item);
                                    setIsEditing(true);
                                  }}
                                >
                                  <EditIcon />
                                </Button>
                              </div>
                            ) : (
                              <div>
                                {(
                                  parseFloat(
                                    getKeyValue(item, "rates")[
                                      columnKey
                                        .toString()
                                        .split("[")[1]
                                        .split("]")[0] as any
                                    ].toString(),
                                  ) * 100
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }) + "%"}
                              </div>
                            )}
                          </TableCell>
                        )}
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ProviderRateConfig;
